import GoogleAdsCards from '../../components/Google/Ads/GoogleAdsCards';
import ListingPage from '../../components/ListingPage';

const GoogleAdsPage = () => {
  return (
    <ListingPage
      entityType="googleAd"
      useStats={true}
      filterBy="name"
      Cards={GoogleAdsCards}
      createRestrictionKey="googleAdsCreate"
    />
  );
};

export default GoogleAdsPage;
